/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersSubscriptionsChangePlanGet200ResponseOneOf model module.
 * @module model/CustomersSubscriptionsChangePlanGet200ResponseOneOf
 * @version 1.0.0
 */
class CustomersSubscriptionsChangePlanGet200ResponseOneOf {
    /**
     * Constructs a new <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf</code>.
     * @alias module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf
     */
    constructor() { 
        
        CustomersSubscriptionsChangePlanGet200ResponseOneOf.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf} obj Optional instance to populate.
     * @return {module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf} The populated <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersSubscriptionsChangePlanGet200ResponseOneOf();

            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }

        return true;
    }


}



/**
 * @member {String} message
 */
CustomersSubscriptionsChangePlanGet200ResponseOneOf.prototype['message'] = undefined;






export default CustomersSubscriptionsChangePlanGet200ResponseOneOf;

